<script setup lang="ts">
import { computed, type Component } from 'vue';
import type { SupportPath } from '@pkg/sanity-utils/types/support';

const props = defineProps<{
  block?: {
    _type: string;
    _key: string;
    theme: string;
    anchorId?: string;
    supportPath: SupportPath;
  };
  config: {
    innerComponent?: Component
  },
}>();

const data = computed(() => ({
  theme: props.block?.theme,
  supportPath: props.block?.supportPath,
}));
</script>

<template>
  <component :is="props.config?.innerComponent" :id="props.block?.anchorId" v-bind="data"/>
</template>
